import React, { useState, useEffect, useRef } from "react";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SaveIcon from "@material-ui/icons/Save";
import CloseIcon from "@material-ui/icons/Close";

import PrintIcon from "@material-ui/icons/Print";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import moment from "moment";
import BiztranControls from "../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../hooks/UseFetchData"
import Modal_Frame from "../biztran_controls/Modal_Frame";
import { DatePickerInput } from 'rc-datepicker';
import Session from "react-session-api";
import { Save } from "@material-ui/icons";

const todate = new Date()
const fromdate = todate.getFullYear() - 1 + '/04/01';

// function useApiRef() {
//   const apiRef = useRef(null);
//   const _columns = useMemo(
//     () =>
//       columns.concat({
//         field: "__HIDDEN__",
//         width: 0,
//         renderCell: (params) => {
//           apiRef.current = params.api;
//           return null;
//         },
//       }),
//     [columns]
//   );
//   return { apiRef, columns: _columns };
// }

const AddExpenseSheet = (props) => {
    //debugger;
    //const classes = useStyles();
    const [TravelRequestNo, setTravelRequestNo] = useState('');
    const [TravelRequestID, setTravelRequestID] = useState('');
    const [TravelRequestDate, setTravelRequestDate] = useState('');
    const [UserName, setUserName] = useState('');
    const [LocationToTravel, setLocationToTravel] = useState('');
    const [PurposeOfTravel, setPurposeOfTravel] = useState('');
    const [ExpenseSheetCreatedOn, setExpenseSheetCreatedOn] = useState('');
    const [ExpenseDate, setExpenseDate] = useState('');
    const [EmpID, setEmpID] = useState('');
    const [Status, setStatus] = useState('');
    const [EmpName, setEmpName] = useState('');
    const [AccountsApprovedByID, setAccountsApprovedByID] = useState(Session.get("UID"));
    const [PaidAmount, setPaidAmount] = useState('');
    const [AccountsApprovedOn, setAccountsApprovedOn] = useState('')
    const [TravelFrom, setTravelFrom] = useState('');
    const [ModeOfTravelID, setModeOfTravelID] = useState('');
    const [ApprovedBy, setApprovedBy] = useState('');
    const [ApprovedOn, setApprovedOn] = useState('');
    const [AccApprovedBy, setAccApprovedBy] = useState(Session.get("UserName"));
    const [responseList, ListfetchData] = UseFetchData();
    const [AccApprovedOn, setAccApprovedOn] = useState('');
    const [PlannedAmount, setPlannedAmount] = useState('');
    const [tolExpAmount, settolExpAmount] = useState('');

    const [tolExpAppAmount, settolExpAppAmount] = useState('');
    const [tolAccAppAmount, settolAccAppAmount] = useState('');

    const [PaidOn, setPaidOn] = useState('');
    const [pagename, setpagename] = useState(props.pagename);
    const [flag, setflag] = useState(props.pagename == "Home" ? true : true);
    const [flag01, setflag01] = useState(false);
    // console.log(props.poppopupData.[FunctionLocation);
    const [TotalPaidAmount, setTotalPaidAmount] = useState('');
    const [PaymentDetails, setPaymentDetails] = useState('');
    const [rows, setRows] = useState([]);
    const [LocationFromTravel, setTravelFromLocation] = useState([]);
    const [columns, setColumns] = useState([]);
    const [response, fetchData] = UseFetchData();
    const [responseAccAp, AccApfetchData] = UseFetchData();
    const [response01, fetchData01] = UseFetchData();
    const [responseprint, fetchDataprint] = UseFetchData();
    const [responseApprove, fetchDataapprove] = UseFetchData();
    const [responseReject, fetchDataReject] = UseFetchData();
    // const fromdate = new Date()
    const [ToDate, setToDate] = useState('');
    const [FromDate, setFromDate] = useState('');
    const [Description, setDescription] = useState('');
    const [ApproxExpAmt, setApproxExpAmt] = useState('');
    const [defaultToDate, setdefaultToDate] = useState('');
    const [ReasonToRejection, setReasonToRejection] = useState('');
    const [ApprovalStatus, setApprovalStatus] = useState([]);

    const [label, setlabel] = useState(false);
    const [label01, setlabel01] = useState(false);
    const [label02, setlabel02] = useState(false);
    const [label03, setlabel03] = useState(false);
    const [label04, setlabel04] = useState(false);
    const [label05, setlabel05] = useState(false);
    const [label06, setlabel06] = useState(false);
    const [label07, setlabel07] = useState(false);

    const poppopupData = () => {
        //debugger;
        // const bodyFormData = new FormData();
        // bodyFormData.append("TravelRequestID", props.TravelRequestID);
        // ListfetchData("Dashboard/GetbyID", bodyFormData);
        const bodyFormData = new FormData();
        bodyFormData.append("TravelRequestID", props.TravelRequestID);
        bodyFormData.append("EmpID", Session.get("UID"));
        bodyFormData.append("CategoryID", Session.get("CategoryID"));
        bodyFormData.append("PageName", 'ApprovalList');
        ListfetchData("ExpMangt/TravelRequestListWeb", bodyFormData)
    }

    const popupGrid = () => {
        debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("TravelRequestID", props.TravelRequestID);
        fetchData("Dashboard/ExpenseList", bodyFormData);

    }

    const submitApprove = () => {
        debugger;
        const bodyFormData = new FormData();
        bodyFormData.append("TravelRequestID", props.TravelRequestID);
        bodyFormData.append("ApprovalRemarks", '');
        bodyFormData.append("ApprovalStatus", "TR Approved");
        bodyFormData.append("ApprovedByID", Session.get("UID"));
        fetchDataapprove("ExpMangt/ApproveTravelRequestWeb", bodyFormData);
    }

    const submitReject = () => {
        debugger;
        const bodyFormData = new FormData();
        if (ReasonToRejection !== "") {
            bodyFormData.append("TravelRequestID", props.TravelRequestID);
            bodyFormData.append("ApprovalRemarks", ReasonToRejection);
            bodyFormData.append("ApprovalStatus", "TR Rejected");
            bodyFormData.append("ApprovedByID", Session.get("UID"));
            fetchDataReject("ExpMangt/ApproveTravelRequestWeb", bodyFormData);
        }
        else {
            alert('Please Enter Reason for Reject.');
        }
    }

    const SaveExpense = (value) => {
        debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("TravelRequestID", value.TravelRequestID);
        bodyFormData.append("EmpID", Session.get("UID"));
        bodyFormData.append("ExpenseID", value.id);

        if (value.AccountsRemarks !== null && value.AccountsRemarks !== "") {
            bodyFormData.append("AccountsRemarks", value.AccountsRemarks);
        } else {
            bodyFormData.append("AccountsRemarks", "");
        }
        if (value.AccountsApprovedAmt !== null && value.AccountsApprovedAmt !== "") {
            if (!isNaN(+value)) {
                alert('Please Enter Numeric Value only !..');
                return;
            }
            else {
                bodyFormData.append("AccountsApprovedAmt", value.AccountsApprovedAmt);
            }
        } else {

            alert('Please Enter Accounts Approved Amount !...');
            return;
        }

        AccApfetchData("Dashboard/ExpAccApproval", bodyFormData);
    }

    useEffect(() => {
        //debugger;
        poppopupData();
        popupGrid();
        console.log("pagename", props.pagename);
    }, [])


    useEffect(() => {
        //debugger;
        if ((responseApprove.Response === true)) {
            alert('Data Saved Succesfully.');
            props.setOpen(false);
            props.PopulateData();
        }
        else if (responseApprove.Response === false) {
            alert('Failed.');
        }
    }, [responseApprove])

    useEffect(() => {
        //debugger;
        if ((responseReject.Response === true)) {
            alert('Data Saved Succesfully.');
            props.setOpen(false);
            props.PopulateData();
        }
        else if (responseReject.Response === false) {
            alert('Failed.');
        }
    }, [responseReject])

    useEffect(() => {
        if (response01.Response == true) {
            //debugger;
            props.setOpen(false);
            props.PopulateData();
        }

    }, [response01])


    const submitForm = () => {
        if (pagename !== "Home") {
            const bodyFormData = new FormData();
            bodyFormData.append("TravelRequestID", props.TravelRequestID);
            bodyFormData.append("PaidOn", PaidOn);
            bodyFormData.append("TotalPaidAmount", TotalPaidAmount);
            bodyFormData.append("PaymentDetails", PaymentDetails);
            fetchData01("Dashboard/PaymentUpdate", bodyFormData);
        } else {
            const bodyFormData = new FormData();
            bodyFormData.append("TravelRequestID", props.TravelRequestID);
            bodyFormData.append("EmpID", Session.get("UID"));
            fetchData01("Dashboard/AccApproval", bodyFormData);
        }


    };


    const Print = () => {
        debugger;
        if (props.TravelRequestID != "" && props.TravelRequestID != null && props.TravelRequestID != undefined) {
            const bodyFormData = new FormData();
            bodyFormData.append("TravelRequestID", props.TravelRequestID);
            fetchDataprint("Dashboard/PDFGenerate", bodyFormData);
        }
    }
    useEffect(() => {
        debugger;
        if (responseprint != undefined && responseprint.length > 0) {
            window.open(responseprint[0].FileURL);
        }
    }, [responseprint])


    useEffect(() => {
        if (responseList !== undefined && responseList.length > 0) {
            //debugger;
            setTravelRequestNo((responseList[0].TravelRequestNo));
            setTravelRequestDate(moment(responseList[0].TravelRequestDate).format('DD-MMM-yyyy'));
            setUserName(responseList[0].EmpName);
            setLocationToTravel(responseList[0].LocationToTravel);
            setTravelFromLocation(responseList[0].LocationFromTravel);
            setPurposeOfTravel(responseList[0].PurposeOfTravel);
            setExpenseSheetCreatedOn(responseList[0].ExpenseSheetCreatedOn);
            setEmpName(responseList[0].EmpName);
            setApprovedBy(responseList[0].ApprovedBy);
            setPlannedAmount(responseList[0].ApproxExpAmount);
            setApprovedOn(responseList[0].ApprovedOn != null && responseList[0].ApprovedOn != "" ? moment(responseList[0].ApprovedOn).format('DD-MMM-yyyy') : null);
            setApproxExpAmt(responseList[0].ApproxExpAmount);
            settolExpAppAmount(responseList[0].TotalApprovedAmount);
            settolAccAppAmount(responseList[0].TotalAccAppAmt);
            setPaidOn(responseList[0].PaidOn != null && responseList[0].PaidOn != "" ? moment(responseList[0].PaidOn).format('DD-MMM-yyyy') : null);
            setTotalPaidAmount(responseList[0].TotalPaidAmount);
            setPaymentDetails(responseList[0].PaymentDetails);
            setStatus(responseList[0].ApprovalStatus);
            setFromDate(responseList[0].FromDate != null && responseList[0].FromDate != "" ? moment(responseList[0].FromDate).format('DD-MMM-yyyy') : null);
            setToDate(responseList[0].ToDate != null && responseList[0].ToDate != "" ? moment(responseList[0].ToDate).format('DD-MMM-yyyy') : null);
            if (responseList[0].ApprovalStatus == "Exp Approved") {
                setflag01(true)
                setflag(false)

            }
            setApprovalStatus(responseList[0].ApprovalStatus);
            setDescription(responseList[0].Description);
        }
    }, [responseList]);


    const openPath = (row) => {
        debugger;
        window.open(row.formattedValue);

    };





    return (<div>
        <Formik initialValues={{
            TravelRequestNo: TravelRequestNo, ExpenseDate: ExpenseDate, EmpID: EmpID, TravelFrom: TravelFrom, ModeOfTravelID: ModeOfTravelID,
            ApprovedBy: ApprovedBy, ApprovedOn: ApprovedOn, AccApprovedBy: AccApprovedBy, AccApprovedOn: AccApprovedOn, PlannedAmount: PlannedAmount, tolExpAmount: tolExpAmount,
            PaidOn: PaidOn, PaidAmount: PaidAmount, PaymentDetails: PaymentDetails
        }}
            onSubmit={() => submitForm()}
            enableReinitialize>
            {formik => {
                return <Form>
                    <Grid item xs={12} spacing={1} container direction="row">
                        <Grid item xs={12} spacing={1} container direction="row">
                            <Grid item xs={4} sm={4} md={2} lg={2}>
                                <label
                                    htmlFor={"TravelRequestNo"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"TR No : "}
                                </label>
                            </Grid>
                            <Grid item xs={8} sm={8} md={4} lg={4}>
                                <label
                                    htmlFor={"TravelRequestNo"}
                                    style={{
                                        // display: "block",
                                        width: "100%",
                                        fontWeight: "bold",
                                    }}
                                >
                                    {TravelRequestNo}
                                </label>
                            </Grid>
                            <Grid item xs={4} sm={8} md={2} lg={2}>
                                <label
                                    htmlFor={"ExpenseDate"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Date : "}
                                </label>
                            </Grid>
                            <Grid item xs={8} sm={8} md={4} lg={4}>
                                <label
                                    htmlFor={"TravelRequestDate"}
                                    style={{
                                        // display: "block",
                                        width: "100%",
                                        fontWeight: "bold",
                                    }}
                                >
                                    {TravelRequestDate}
                                </label>
                            </Grid>
                            <Grid item xs={6} sm={6} md={6} lg={6}>
                                <label
                                    htmlFor={"EmpID"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Employee Name: "}
                                </label>
                            </Grid>
                            <Grid item xs={6} sm={6} md={6} lg={6}>
                                <label
                                    htmlFor={"EmpName"}
                                    style={{
                                        // display: "block",
                                        width: "100%",
                                        fontWeight: "bold",
                                    }}
                                >
                                    {EmpName}
                                </label>
                            </Grid>

                        </Grid>

                        <Grid item xs={12} spacing={1} container rowSpacing={2} direction="row">
                            <Grid item xs={6} sm={6} md={6} lg={6}>
                                <label
                                    htmlFor={"TravelFromLocation"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"From Location :"}
                                </label>
                            </Grid>
                            <Grid item xs={6} sm={6} md={6} lg={6}>
                                <label
                                    htmlFor={"LocationFromTravel"}
                                    style={{
                                        // display: "block",
                                        fontWeight: "bold",
                                        width: "100%",
                                    }}
                                >
                                    {LocationFromTravel}
                                </label>
                            </Grid>
                            <Grid item xs={6}>
                                <label
                                    htmlFor={"TravelFrom"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"To Location:"}
                                </label>
                            </Grid>
                            <Grid item xs={6} >
                                <label
                                    htmlFor={"LocationToTravel"}
                                    style={{
                                        // display: "block",
                                        fontWeight: "bold",
                                        width: "100%",
                                    }}
                                >
                                    {LocationToTravel}
                                </label>
                            </Grid>
                            <Grid item xs={6}>
                                <label
                                    htmlFor={"ModeOfTravelID"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Purpose :"}
                                </label>
                            </Grid>
                            <Grid item xs={6} >
                                <label
                                    htmlFor={"PurposeOfTravel"}
                                    style={{
                                        // display: "block",
                                        fontWeight: "bold",
                                        width: "100%",
                                    }}
                                >
                                    {PurposeOfTravel}
                                </label>
                            </Grid>

                        </Grid>
                        <Grid item xs={12} spacing={1} container direction="row">
                            <Grid item xs={6}>
                                <label
                                    htmlFor={"ApprovedBy"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"From Date : "}
                                </label>
                            </Grid>
                            <Grid item xs={6} >
                                <label
                                    htmlFor={"ApprovedBy"}
                                    style={{
                                        // display: "block",
                                        fontWeight: "bold",
                                        width: "100%",
                                    }}
                                >
                                    {FromDate}
                                </label>
                            </Grid>
                            <Grid item xs={6}>
                                <label
                                    htmlFor={"ApprovedOn"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"To Date :"}
                                </label>
                            </Grid>
                            <Grid item xs={2} >
                                <label
                                    htmlFor={"ApprovedOn"}
                                    style={{
                                        // display: "block",
                                        fontWeight: "bold",
                                        width: "100%",
                                    }}
                                >
                                    {ToDate}
                                </label>
                            </Grid>

                        </Grid>

                        <Grid item xs={12} spacing={1} container direction="row">

                            <Grid item xs={6}>
                                <label
                                    htmlFor={"ApproxExpAmt"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Description :"}
                                </label>
                            </Grid>
                            <Grid item xs={6} >
                                <label
                                    htmlFor={"ApproxExpAmt"}
                                    style={{
                                        // display: "block",
                                        width: "100%",
                                        fontWeight: "bold",
                                    }}
                                >
                                    {Description}
                                </label>
                            </Grid>


                            <Grid item xs={6}>
                                <label
                                    htmlFor={"tolExpAmount"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Approx Amount :"}
                                </label>
                            </Grid>
                            <Grid item xs={6} >
                                <label
                                    htmlFor={"tolExpAmount"}
                                    style={{
                                        fontWeight: "bold",
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {ApproxExpAmt}
                                </label>
                            </Grid>


                        </Grid>




                        <Grid item xs={12} spacing={1} container rowSpacing={2} direction="row" >
                            <Grid item xs={4}>
                                <label
                                    htmlFor={"PaymentDetails"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                    }}
                                >
                                    {"Reason To Reject :"}
                                </label>
                            </Grid>
                            <Grid item xs={8} >
                                <BiztranControlsFormik
                                    autoFocus="autofocus"
                                    control="input"
                                    type="text"
                                    name="ReasonToRejection"
                                    //ref={ref}
                                    value={ReasonToRejection}
                                    //options={ASIcmb}                   
                                    onChange={(e) => {
                                        setReasonToRejection(e.target.value)
                                        //handleChange()
                                    }}
                                />
                                <label
                                    htmlFor={"PaymentDetails"}
                                    style={{
                                        // display: "block",
                                        width: "100%",
                                        fontWeight: "bold",
                                    }}
                                >
                                    {PaymentDetails}
                                </label>
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <div style={{ width: '100%' }}>
                                <div style={{ display: 'flex', marginTop: 5, justifyContent: 'center', alignContent: "center" }}>

                                    <BiztranControls.Button
                                        text="Approve"
                                        startIcon={<SaveIcon />}
                                        onClick={submitApprove}
                                    //type="submit"
                                    />
                                    <BiztranControls.Button
                                        text="Reject"
                                        startIcon={<SaveIcon />}
                                        onClick={submitReject}
                                    />
                                    {/* <BiztranControls.Button
                                        text="CLOSE"
                                        startIcon={<CloseIcon />}
                                        onClick={() => { props.setOpen(false); }}
                                    /> */}
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </Form>
            }}
        </Formik>

    </div >)

}
export default AddExpenseSheet;